export const BASE_URL = 'http://backend.khoj.info/'
export const API_URL = BASE_URL + 'api/'

export const EMPLOYEES_API = API_URL + 'employees/'

export const CATEGORIES_API = API_URL + 'categories/'
export const FEATURED_CATEGORIES_API = API_URL + 'featuredCategories/'
export const SUBCATEGORIES_API = API_URL + 'subcategories/'

export const ORGANIZATIONS_API = API_URL + 'organizations/'

export const BRANCHES_API = API_URL + 'branches/'

export const ORGANIZATION_PHONES_API = API_URL + 'organizationPhones/'
export const ORGANIZATION_LINKS_API = API_URL + 'organizationLinks/'
export const ORGANIZATION_EMAILS_API = API_URL + 'organizationEmails/'

export const SUBCATEGORY_SECTIONS_API = API_URL + 'subcategorySections/'
export const SUBCATEGORY_NDI_API = API_URL + 'subcatNDICards/'
export const SUBCATEGORY_NI_API = API_URL + 'subcatNICards/'
export const SUBCATEGORY_STAT_API = API_URL + 'subcatStatCards/'

export const ORGANIZATIONS_STAT_API = API_URL + 'orgStatCards/'
export const ORGANIZATIONS_NDI_API = API_URL + 'orgNDICards/'
export const ORGANIZATIONS_NI_API = API_URL + 'orgNICards/'

export const HOME_PARTNERS_API = API_URL + 'homePartners/'
export const HOME_COUNTERS_API = API_URL + 'homeCounters/'
export const SLIDERS_API = API_URL + 'sliders/'
export const SOCIAL_LINKS_API = API_URL + 'socialLinks/'

const LOCATIONS_API = 'https://backend.anthill.club/api/antApi/locations/'

export const DIVISIONS_API = LOCATIONS_API + 'divisions/'
export const DISTRICTS_API = LOCATIONS_API + 'districts/'
export const AREAS_API = LOCATIONS_API + 'areas/'